import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { CATEGORY_LABEL } from "@/lib/categories";

export default function CourseCard({ course, index = 0, testId }) {
  return (
    <Link
      to={`/kurslar/${course.slug}`}
      data-testid={testId || `course-card-${course.slug}`}
      className="course-card group block bg-white rounded-2xl overflow-hidden border border-black/5 hover:border-black/20 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)] transition-shadow"
    >
      <div className="aspect-[4/3] overflow-hidden bg-neutral-100">
        <img
          src={course.hero_image}
          alt={course.title}
          loading={index < 3 ? "eager" : "lazy"}
          className="course-card__img w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="overline text-[color:var(--ek-accent)] mb-2">
          {CATEGORY_LABEL[course.category] || course.category}
        </div>
        <h3 className="font-display text-xl md:text-2xl tracking-tight leading-tight mb-2 text-neutral-900">
          {course.title}
        </h3>
        <p className="text-sm text-neutral-500 leading-relaxed line-clamp-2 mb-4">
          {course.short_desc}
        </p>
        <div className="flex items-center justify-between pt-4 border-t border-black/5">
          <span className="text-xs text-neutral-500 flex items-center gap-1.5">
            <Clock size={13} /> {course.duration}
          </span>
          <span className="text-sm font-medium text-neutral-900 flex items-center gap-1 group-hover:text-[color:var(--ek-accent)] transition-colors">
            Detay <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
          </span>
        </div>
      </div>
    </Link>
  );
}
